module.exports = __webpack_public_path__ + "static/img/far4_active.b1879dd3.jpg";